import { IconProps } from "./types";
import React from "react";

export const TriangleIcon = ({
  className,
  fill = "currentColor",
  width = 10,
  height = 10,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 10 10"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M1.24927 2.85983L4.99927 7.14014L8.74927 2.85983L1.24927 2.85983Z"
      fill={fill}
    />
  </svg>
);
